import { render } from "./qualityInspectionStatistics.vue?vue&type=template&id=35b35d8a&scoped=true"
import script from "./qualityInspectionStatistics.vue?vue&type=script&lang=js"
export * from "./qualityInspectionStatistics.vue?vue&type=script&lang=js"

import "./qualityInspectionStatistics.vue?vue&type=style&index=0&id=35b35d8a&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b35d8a"]])

export default __exports__